import React from "react";
import { Divider } from "@material-ui/core";
import FlexBox from "../../../components/elements/v2/Box/FlexBox";
import { Title } from "../../../components/pages/SearchPage/components/FilterSection";
import styled from "styled-components";
import Switch from "../../../components/elements/v2/Switch/Switch";
import { useToggleRefinement } from "react-instantsearch";
import ConditionalDisplay from "../../../components/elements/ConditionalDisplay";

type Props = {
  label: string;
  attribute: string;
};

export default function SwitchFilter({ label, attribute }: Props) {
  const { value, refine, canRefine } = useToggleRefinement({ attribute });

  const handleChange = () => {
    refine(value);
  };

  return (
    <ConditionalDisplay hidden={!canRefine}>
      <Container>
        <Title>{label}</Title>
        <Switch onChange={handleChange} checked={value.isRefined} />
      </Container>
      <Divider variant="middle" component="p" />
    </ConditionalDisplay>
  );
}

const Container = styled(FlexBox)`
  justify-content: space-between;
  padding: 12px 16px;
`;
